import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/App";

const LINKS = [
  { label: "Why Pickleball", href: "#why", tid: "nav-link-why-pickleball" },
  { label: "What We Deliver", href: "#deliver", tid: "nav-link-deliverables" },
  { label: "Court Specs", href: "#dimensions", tid: "nav-link-dimensions" },
  { label: "Event Ideas", href: "#ideas", tid: "nav-link-ideas" },
  { label: "Add-ons", href: "#addons", tid: "nav-link-add-ons" },
  { label: "Process", href: "#process", tid: "nav-link-process" },
  { label: "FAQ", href: "#faq", tid: "nav-link-faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "border-b border-white/10 bg-obsidian/80 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <button onClick={() => go("#top")} data-testid="nav-brand-logo" aria-label="PopUp Pickleball home">
          <Logo />
        </button>
        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={l.tid}
              onClick={() => go(l.href)}
              className="text-sm font-semibold text-white/70 transition-colors hover:text-volt"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="hidden items-center gap-5 lg:flex">
          <a href="tel:0434879138" data-testid="nav-phone-link" className="font-mono text-xs tracking-[0.2em] text-white/50 transition-colors hover:text-volt">0434 879 138</a>
          <button
            data-testid="nav-cta-get-quote"
            onClick={() => go("#quote")}
            className="group flex items-center gap-2 rounded-full bg-volt px-5 py-2.5 text-sm font-bold uppercase tracking-wide text-obsidian transition-colors hover:bg-volt-hover"
          >
            Get a quote
            <ArrowUpRight size={16} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </button>
        </div>
        <button
          className="text-white lg:hidden"
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>
      {open && (
        <div className="border-t border-white/10 bg-obsidian/95 backdrop-blur-xl lg:hidden" data-testid="nav-mobile-panel">
          <div className="flex flex-col gap-1 px-5 py-4">
            {LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`${l.tid}-mobile`}
                onClick={() => go(l.href)}
                className="py-3 text-left font-display text-2xl font-bold uppercase text-white/85"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-cta-get-quote-mobile"
              onClick={() => go("#quote")}
              className="mt-3 rounded-full bg-volt py-3 text-sm font-bold uppercase text-obsidian"
            >
              Get a quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
